/** Shared profile / team-member card cover (public/assets/images/dashboard/agents/). */
export const AGENT_PROFILE_COVER_URL =
  '/assets/images/dashboard/agents/profile-cover.webp';

export const AGENT_PROFILE_COVER_STYLE = {
  backgroundImage: `url(${AGENT_PROFILE_COVER_URL})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};
